import LiveCalls from 'components/page-components/agents/LiveCalls';
import MenuContainer from 'components/custom-components/menu/MenuContainer';
import { useError } from 'error-provider/ErrorProvider';
import {
    useGetAgentVoicesQuery,
    useGetCurrentUserMinutesQuery,
    useGetMeQuery,
    useGetUserAgentsQuery,
} from 'graphql/generated';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATHS } from 'router/routes';
import Agent from './components/Agent';
import CookieBanner from 'components/custom-components/cookie/CookieBanner';
import Loading from './components/Loading';
import { PhoneStatusType } from 'types';


import { useUserData } from 'context/UserDataProvider';
import type { UserData } from 'hooks/useGetUserData';

import { Box, Button, Text } from '@chakra-ui/react';
import SubscribeBanner from 'components/custom-components/SubscribeBanner';






const MyAgent = () => {
    const navigate = useNavigate();
    const { userData: userDataFromContext, isLoading: isLoadingUserData } = useUserData();
    const myUserData = userDataFromContext as UserData | null;


    const { showError } = useError();
    const location = useLocation();
    const { state } = location;

    const [isShowCookie, setIsShowCookie] = useState(true);


    const { data: agentsData, loading: isLoadingAgents } = useGetUserAgentsQuery({
        onError(error: Error | undefined) {
            showError(undefined, error);
        },
    });


    const { data: agentsVoicesData } = useGetAgentVoicesQuery({
        onError(error: Error | undefined) {
            showError(undefined, error);
        },
    });


    const { data: currentMinutesData, loading: isLoadingCurrentMinutes } = useGetCurrentUserMinutesQuery({
        fetchPolicy: 'network-only',
        onError(error: Error | undefined) {
            showError(undefined, error);
        },
    });


    const { data: userData } = useGetMeQuery({
        onError(error: Error | undefined) {
            showError(undefined, error);
        },
    });

    const agents = useMemo(() => agentsData?.getUserAgents.agents ?? [], [agentsData]);
    const agentVoices = useMemo(() => agentsVoicesData?.getAgentVoices.voices ?? [], [agentsVoicesData]);
    const currentMinutes = useMemo(() => currentMinutesData?.getCurrentUserMinutes ?? 0, [currentMinutesData]);
    const isCancelled = myUserData?.db_subscription_information?.status === 'canceled' || myUserData?.db_subscription_information?.cancel_at_period_end;
    const myEmail = useMemo(() => {
        if (userData?.getMe.__typename === 'UserModelType') {
            return userData.getMe.email;
        }
        return '';
    }, [userData]);

    const acceptCookies = () => {
        setIsShowCookie(false);
    };
    const agentData = myUserData?.agent_info;
    if (!isLoadingUserData && !myUserData?.db_subscription_information) {
        navigate(PATHS.AGENT_DEMO_PAGE);
        return null;
    }
    if (!isLoadingUserData && myUserData?.db_subscription_information) {
        const hasAccess = myUserData?.db_subscription_information?.has_access;
        if (!hasAccess) {
            navigate(PATHS.SUBSCRIPTION_PLAN);
        }
    }
    if (isLoadingUserData) {
        return <Loading />;
    }


    return (
        <>
            <MenuContainer title=''>
                {(isLoadingAgents || !agentsData) && <Loading />}

                {/* Show banner if subscription_info is null */}
                {myUserData?.db_subscription_information == null && (
                    <SubscribeBanner
                        agentId={agents.length > 0 ? agents[0].id : ""}
                        minutesRemain={myUserData?.minutes_info ? parseInt(`${myUserData.minutes_info}`) : 0}
                        onAddCreditCard={() => navigate(PATHS.SUBSCRIPTION_PLAN)}
                    />
                )}
                {isCancelled && (
                    <Box mb={4}>
                        {myUserData?.db_subscription_information?.current_period_end ? (
                            <Text color='red.500' fontWeight='bold'>
                                Your subscription has been cancelled. However, you will have access through {new Date(myUserData.db_subscription_information.current_period_end).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' })}. To continue services after that period, please renew your subscription.
                            </Text>
                        ) : (
                            <Text color='red.500' fontWeight='bold'>
                                Your subscription has been cancelled. Please renew your subscription to continue using agent services.
                            </Text>
                        )}
                        <Button mt={2} colorScheme='blue' onClick={() => navigate(PATHS.SUBSCRIPTION_PLAN)}>
                            Renew Subscription
                        </Button>
                    </Box>
                )}
                {agents.map((agent: any) => (
                    <Agent
                        key={agent.id}
                        agentVoices={agentVoices}
                        currentMinutes={currentMinutes}
                        isLoadingCurrentMinutes={isLoadingCurrentMinutes}
                        myEmail={myEmail}
                        phoneStatus={(agent.businessAddress?.bundleStatus as PhoneStatusType) ?? PhoneStatusType.draft}
                        {...agent}
                        phoneNumber={agentData?.phone_number ?? ''}
                    />
                ))}
                <LiveCalls />
                
            </MenuContainer>
            {isShowCookie && state?.from?.path === PATHS.PHONE_PICK && <CookieBanner acceptCookies={acceptCookies} />}
        </>
    );
};

export default MyAgent;
